export const START_WHOISWHO_GAME_COMPLETED = "whoIsWho/startCompleted";
export const NEXT_WHOISWHO_HINT_COMPLETED = "whoIsWho/nextHintCompleted";
export const GUESS_WHOISWHO_COMPLETED = "whoIsWho/guessCompleted";
export const REVEAL_WHOISWHO_COMPLETED = "whoIsWho/revealCompleted";
export const CLEAR_WHOISWHO_FEEDBACK = "whoIsWho/clearFeedback";
export const WHOISWHO_AUTOCOMPLETE_COMPLETED = "WHOISWHO_AUTOCOMPLETE_COMPLETED";
export const WHOISWHO_AUTOCOMPLETE_CLEARED = "WHOISWHO_AUTOCOMPLETE_CLEARED";
